import { strings } from '../../utils';
import definitions from './features/definitions/_definitionsLoader';
const defaults = require('lodash/defaults');
const cloneDeep = require('lodash/cloneDeep');

export default class Feature {
    static build(props) {
        if (!props.type || !definitions[props.type]) {
            throw new Error(`Invalid feature type "${props.type}"`);
        }

        let presetDef = props.preset ? definitions[props.preset] : {};
        
        // Old config options should be replaced
        delete props.availableConfig;
        delete props.propertyTabs;
        
        // left/top (ie: decreasing definition specificity) takes precedence
        let definition = {};
        defaults(
            definition,
            cloneDeep(props),
            cloneDeep(presetDef),
            cloneDeep(definitions[props.type]),
            cloneDeep(definitions.default)
        );

        // Auto-generate missing props and enforce minimums/maximums
        if (!definition.id) definition.id = this.generateId();
        if (!definition.name) definition.name = definition.typeName + '_' + definition.id;
        if (definition.width < definition.minWidth) definition.width = definition.minWidth;
        if (definition.height < definition.minHeight) definition.height = definition.minHeight;
        
        return definition;
    }

    static generateId() {
        return strings.random(6);
    }
}